import * as React from 'react';

import { Input } from '@independent-software/typeui/controls/Input';
import { Form } from '@independent-software/typeui/controls/Form';
import { MarkdownTextarea } from '@independent-software/typeui/modules/MarkdownTextarea';
import { Flex } from '@independent-software/typeui/controls/Flex';

import { Project } from '../../resource/';
import { Section } from '../../modules';

interface IProps {
  /** Initial form data. */
  data: Project;
  /** Called whenever form changes. */
  onChange: (data: Project, forceupdate: boolean) => void;
  /** Called whenever a field validates. Returns validation state for whole form. */
  onValidate: (valid: boolean) => void;
  /** 
   * Mark form as dirty. If dirty, it will show error messages for all fields,
   * even pristine fields.
   */  
  dirty?: boolean;
}

const ProjectForm = (props: IProps) => {
  
  const renderName = () =>
    <Form.Field 
      name="name" label="Name"
      value={props.data.name}
      control={(<Input type="text" placeholder="Name" fluid/>)}
      required={{message: "A project name is required."}}
      minLength={{length: 3, message: "Project name must be at least 3 characters."}}
      maxLength={{length: 255, message: "Project name may not have more than 255 characters."}}
      hint={(<React.Fragment>Please enter a project name.</React.Fragment>)}/>

  const renderReference = () =>
    <Form.Field 
      name="reference" label="Reference"
      value={props.data.reference}
      control={(<Input type="text" placeholder="Reference" fluid/>)}
      maxLength={{length: 255, message: "Project reference may not have more than 255 characters."}}
      hint={(<React.Fragment>Please enter a project reference.</React.Fragment>)}/>

  const renderAgency = () =>
    <Form.Field 
      name="agency" label="Agency"
      value={props.data.agency}
      control={(<Input type="text" placeholder="Agency" fluid/>)}
      maxLength={{length: 255, message: "Project agency may not have more than 255 characters."}}
      hint={(<React.Fragment>Please enter a project agency.</React.Fragment>)}/>

  const renderManager = () =>
    <Form.Field 
      name="manager" label="Manager"
      value={props.data.manager}
      control={(<Input type="text" placeholder="Manager" fluid/>)}
      maxLength={{length: 255, message: "Project manager may not have more than 255 characters."}}
      hint={(<React.Fragment>Please enter a project manager.</React.Fragment>)}/>      

  const renderContact = () =>
    <Form.Field 
      name="contact" label="Contact"
      value={props.data.contact}
      control={(<Input type="text" placeholder="Contact" fluid/>)}
      maxLength={{length: 255, message: "Project contact may not have more than 255 characters."}}
      hint={(<React.Fragment>Please enter a project contact.</React.Fragment>)}/>      

  const renderDescription = () =>
    <Form.Field 
      name="description" label="Description"
      value={props.data.description}
      control={(<MarkdownTextarea rows={16} fluid/>)}
      hint={(<React.Fragment>Please enter a project description.</React.Fragment>)}/>      

  return (
    <Form
      data={props.data} dirty={props.dirty} onChange={props.onChange} onValidate={props.onValidate}>
      <Section padded>
        <Flex.Columns count={2}>
          <>
          {renderName()}
          {renderReference()}
          {renderAgency()}
          {renderManager()}
          {renderContact()}
          </>
          {renderDescription()}    
        </Flex.Columns>
      </Section>
    </Form>
  )
}

export { ProjectForm }

